import { NodeForm } from '@/components/nodes/NodeForm'
import type { Project, User, Task } from '@/types'
import { Status, Priority, Horizon, TaskType } from '@/types/enums'
import { nodeFormConfigs } from '@/lib/config/node-form-configs'

export interface TaskFormData {
  type: TaskType
  name: string
  description?: string
  status: Status
  priority: Priority
  horizon: Horizon
  dueDate?: Date
  assigneeId?: string
  workspaceId: string
  projectIds?: string[]
  dependencyIds?: string[]
  userIds?: string[]
}

interface TaskFormProps {
  mode: 'create' | 'edit'
  initialData?: Partial<TaskFormData>
  initialProjects?: Project[]
  initialDependencies?: Task[]
  initialUsers?: User[]
  excludeTaskId?: string // For filtering out current task from dependencies in edit mode
  onSubmit: (data: TaskFormData) => Promise<void>
  onCancel: () => void
  onDirtyChange?: (isDirty: boolean) => void
  loading?: boolean
  submitText?: string
  cancelText?: string
  title?: string
  description?: string
  simplified?: boolean // Show only name and description for onboarding
}

export function TaskForm({
  mode,
  initialData,
  initialProjects = [],
  initialDependencies = [],
  initialUsers = [],
  excludeTaskId,
  onSubmit,
  onCancel,
  onDirtyChange,
  loading = false,
  submitText,
  cancelText,
  title = 'Task Details',
  description: formDescription,
  simplified = false,
}: TaskFormProps) {
  const handleSubmit = async (data: Record<string, unknown>) => {
    await onSubmit(data as unknown as TaskFormData)
  }

  const config = simplified ? nodeFormConfigs.simplified : nodeFormConfigs.task

  return (
    <NodeForm
      mode={mode}
      config={config}
      initialData={initialData}
      initialProjects={initialProjects}
      initialDependencies={initialDependencies}
      initialUsers={initialUsers}
      excludeTaskId={excludeTaskId}
      onSubmit={handleSubmit}
      onCancel={onCancel}
      submitText={submitText}
      cancelText={cancelText}
      loading={loading}
      title={title}
      description={formDescription}
      onDirtyChange={onDirtyChange}
      simplified={simplified}
    />
  )
}
